import { useFindIngestionSettings } from "~/gen/api/hooks"

export const useFindIngestionSettingsQuery = () => useFindIngestionSettings()
